import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsAllFieldsShownSvg = lazy(() => import('./svg-components/digital-forms-all-fields-shown-svg'));

const DigitalFormsAllFieldsShownSvg = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsAllFieldsShownSvg {...rest} />
  </Suspense>
);

export default DigitalFormsAllFieldsShownSvg;
